import axios from 'axios';
import { Toast } from 'vant';

/**
 * 走势数据接口配置
 *
 * 开发环境：使用代理 /trend-api (配置在 vue.config.js)
 * 生产环境：直接请求目标服务器
 *
 * 【重要】切换到正式域名时，请修改下方 TREND_API_BASE_URL 的值
 */
const TREND_API_BASE_URL =
  process.env.NODE_ENV === 'production' ? 'https://go.yichenbao.cn' : '/trend-api'; // 开发环境使用代理

// 创建专门用于走势数据的 axios 实例
const trendService = axios.create({
  baseURL: TREND_API_BASE_URL,
  timeout: 250000 * 2,
  headers: {
    'Content-Type': 'application/json',
  },
});

// request 拦截器
trendService.interceptors.request.use(
  config => {
    // 如果是 POST 或 PUT 请求，确保 Content-Type 正确
    if (config.method === 'post' || config.method === 'put') {
      if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
      }
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  },
);

// response 拦截器
trendService.interceptors.response.use(
  response => {
    // 成功响应
    if (response.data.code === 200 || response.data.code === 0) {
      Toast.clear();
      return response.data;
    }

    // 其他错误码处理
    if (response.data.msg || response.data.message) {
      Toast(response.data.msg || response.data.message);
    }

    return Promise.reject(response.data);
  },
  error => {
    // 网络错误处理
    if (error.response) {
      Toast(`请求失败: ${error.response.status}`);
    } else if (error.request) {
      Toast('网络请求失败, 请检查网络连接');
    } else {
      Toast('请求配置错误');
    }
    return Promise.reject(error);
  },
);

export default trendService;
